"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapMatrix = exports.reverseMatrix = exports.insertInMatrix = exports.buildMatrix = exports.createMatrix = void 0;
const createMatrix = (array) => {
    const matrix = (array || []);
    matrix.width = matrix.reduce((max, row) => (row.length > max ? row.length : max), 0);
    return matrix;
};
exports.createMatrix = createMatrix;
const buildMatrix = (length, width, value) => (0, exports.createMatrix)(Array.from({ length }).map(() => Array.from({ length: width }).map(() => value)));
exports.buildMatrix = buildMatrix;
const insertInMatrix = (matrix, x, y, item) => (!matrix || x < 0 || y < 0 || x >= matrix.length || y >= matrix[x].length
    ? matrix
    : (0, exports.createMatrix)([...matrix.slice(0, x), [...matrix[x].slice(0, y), item(), ...matrix[x].slice(y + 1)], ...matrix.slice(x + 1)]));
exports.insertInMatrix = insertInMatrix;
const reverseMatrix = (matrix) => (0, exports.createMatrix)((matrix || []).map((row) => row.reverse()).reverse());
exports.reverseMatrix = reverseMatrix;
const mapMatrix = (matrix, callback) => (0, exports.createMatrix)(matrix || []).flatMap((row) => row.flatMap((i) => callback && callback(i)));
exports.mapMatrix = mapMatrix;
//# sourceMappingURL=array.js.map